<script>
import moveCopy from '@/CommonDP/components/documentRelevant/moveCopy.backup.vue'
export default {
    extends: moveCopy,
    mounted() {
        this.isCopyAnnotation = 1
    }
}
</script>